import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/ims/stock-return/{id}/reject`。body 含 rejectReason＋updatedAt。 */
export async function rejectStockReturn(id, payload) {
  const { data: raw } = await request.post(
    `/ims/stock-return/${id}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
